// Types for KYC Status
export type EKYCStatus = 'notinitiated' | 'initiated' | 'rejected' | 'approved';
export type PKYCStatus =
  | 'notinitiated'
  | 'initiated'
  | 'underreview'
  | 'underrejection'
  | 'underverifier'
  | 'pendingapproval'
  | 'rejected'
  | 'approved';

// E-KYC Status Mapping
export const EKYC_STATUS_LABELS: Record<EKYCStatus, string> = {
  notinitiated: 'Not Initiated',
  initiated: 'Initiated',
  rejected: 'Rejected',
  approved: 'Approved',
};

// P-KYC Status Mapping
export const PKYC_STATUS_LABELS: Record<PKYCStatus, string> = {
  notinitiated: 'Not Initiated',
  initiated: 'Initiated',
  underreview: 'Under Review',
  underrejection: 'Under Rejection',
  underverifier: 'Under Verifier',
  pendingapproval: 'Pending Approval',
  rejected: 'Rejected',
  approved: 'Approved',
};

// Helper function to get E-KYC status label
export const getEkycStatusLabel = (status: EKYCStatus): string => {
  return EKYC_STATUS_LABELS[status] || status;
};

// Helper function to get P-KYC status label
export const getPkycStatusLabel = (status: PKYCStatus): string => {
  return PKYC_STATUS_LABELS[status] || status;
}; 